<template>
  <div class="deviceEchartsItem">
    <div class="title">
      <div
        v-if="paramsEcharts.length === 1 && !paramsEcharts?.children?.length"
        class="title-single"
      >
        {{ cascaderValue[0] }}
      </div>
      <el-cascader
        v-else
        v-model="cascaderValue"
        :options="paramsEcharts"
        :props="{ expandTrigger: 'hover' }"
        @change="handleChange"
      ></el-cascader>
    </div>
    <div class="content">
      <PublicEcharts
        :id="`${assetId}-${deviceId}-${id}`"
        :chartsData="echartsData"
        :options="dealLineData()"
        usePropsOptions
      />
    </div>
  </div>
</template>
<script>
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
import { getProjectVal, matchingAirEchartsName } from "@/assets/js/utils";
export default {
  components: { PublicEcharts },
  name: "DeviceEchartsItem",
  props: {
    id: {
      type: String | Number,
      default: "1",
    },
    paramsEcharts: {
      type: Array,
      default: () => [],
    },
    deviceTypes: {
      type: String,
      default: "中央空调主机",
    },
    timeValue: {
      type: Number,
      default: new Date().getTime(),
    },
    deviceId: {
      type: String,
      default: "0",
    },
    deviceName: {
      type: String,
      default: "全部",
    },
    assetId: {
      type: String,
      default: "",
    },
    //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
    energyType: {
      type: String,
      default: "cool",
    },
  },
  data() {
    return {
      cascaderValue: [],
      echartsData: {
        xData: [],
        series: [],
      },
      echartsOption: {},
    };
  },
  methods: {
    getDefaultValue() {
      const arr = [this.paramsEcharts?.[0].value];
      this.paramsEcharts?.[0]?.children?.length &&
        arr.push(this.paramsEcharts?.[0]?.children[0].value);
      this.cascaderValue = arr;
    },
    handleChange(val) {
      this.getChartsByParameters();
    },
    //根据参数获取图表
    async getChartsByParameters() {
      const params = {
        assetId: this.assetId,
        assetType: "中央空调系统",
        deviceId: this.deviceId,
        deviceType:
          this.deviceTypes === "主机能效" ? "中央空调主机" : this.deviceTypes,
        date: this.$moment(this.timeValue).format("yyyy-MM-DD"),
        name: this.cascaderValue?.[this.cascaderValue.length - 1],
        modular: "环境监测",
        projectId: getProjectVal("Id"),
        dateType: "DAY",
      };
      if (this.paramsEcharts.length > 1) {
        if (this.cascaderValue[0] === "冷冻水") {
          params.type = "freeze";
        } else if (this.cascaderValue[0] === "冷却水") {
          params.type = "burial";
        }
      }
      if (this.cascaderValue[0] === "锅炉效率") {
        params.energyType = this.energyType;
      }
      if (this.deviceName === "全部" && this.deviceTypes !== "分集水器") {
        delete params.deviceId;
      }
      let res = await api.ACRGetChartsByParameters(params);
      if (res && res.data.code == 200) {
        const newData = {
          xData: [],
          series: [],
        };
        Array.isArray(res.data.data) &&
          res.data.data.forEach((item, index) => {
            if (index === 0 && !!item?.unit) {
              newData.unit = item.unit;
            }
            newData.xData.push(this.$moment(item.ts).format("HH:mm:ss"));
            Array.isArray(item?.value) &&
              item.value.map((v, i) => {
                const { name, value } = v;
                const newName = matchingAirEchartsName(name);
                const seriesIndex = this._.findIndex(
                  newData.series,
                  function (o) {
                    return o.name === newName;
                  }
                );
                if (seriesIndex == -1) {
                  const obj = {
                    name: newName,
                    data: [value],
                    type: "line",
                    symbolSize: 8,
                    itemStyle: {
                      color: EchartsLightColor[i],
                    },
                    animation: true,
                  };
                  newData.series.push(obj);
                } else {
                  newData.series[seriesIndex].data.push(value);
                }
              });
          });
        this.echartsData = newData;
      } else {
        console.log("获取图表失败");
      }
    },
    dealLineData() {
      let _this = this;
      let option = {
        grid: {
          top: "60px",
          left: "40px",
          right: "10px",
          bottom: "30px",
        },
        xAxis: {
          type: "category",
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
          data: [],
        },
        yAxis: {
          type: "category",
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
            margin: 15,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            data: [],
            type: "line",
          },
        ],
      };
      if (this.echartsData?.xData?.length && this.echartsData?.series?.length) {
        option = {
          grid: {
            top: "60px",
            left: "40px",
            right: "10px",
            bottom: "30px",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
            formatter: function (params) {
              let result = params[0].name + "<br>";
              params.forEach(function (item) {
                result +=
                  item.marker +
                  " " +
                  item.seriesName +
                  " : " +
                  item.value +
                  `${_this.echartsData?.unit || ""}` +
                  "</br>";
              });
              return result;
            },
          },
          legend: {
            top: "top",
            right: "10",
            textStyle: {
              color: "#333",
              fontSize: 12,
            },
          },
          xAxis: {
            type: "category",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#CBCBCB",
              fontSize: 12,
              margin: 15,
            },
            data: this.echartsData?.xData || [],
          },
          yAxis: {
            type: "value",
            name: this.echartsData?.unit
              ? `单位(${this.echartsData?.unit})`
              : "",
            nameTextStyle: {
              color: "#666",
              fontSize: 12,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            axisLabel: {
              color: "#999",
              fontSize: 12,
            },
            splitLine: {
              lineStyle: {
                type: "solid",
                color: "#EBEBEB",
              },
            },
            max: function (value) {
              if (value.max < 0) {
                return Math.ceil(value.max * 0.9);
              }
            },
            min: function (value) {
              if (value.min > 0) {
                return Math.floor(value.min * 0.9);
              }
            },
          },
          dataZoom: [
            {
              type: "inside",
            },
          ],
          series: this.echartsData?.series,
        };
      }
      return option;
    },
  },
  computed: {
    styleObj: function () {
      return this.paramsEcharts.length === 1
        ? { width: "100%", height: "100%" }
        : {};
    },
  },
  watch: {
    timeValue(val) {
      this.getChartsByParameters();
    },
  },
  created() {
    this.getDefaultValue();
  },
  mounted() {
    this.getChartsByParameters();
    this.$bus.$on("getChartsByParameters", () => {
      this.getChartsByParameters();
    });
  },
  beforeDestroy() {
    this.$bus.$off("getChartsByParameters");
  },
};
</script>
<style lang="scss" scoped>
.deviceEchartsItem {
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 0.005208rem solid #e2d7d7;
  padding: 8px;
  box-shadow: 2px 2px 5px #808080;

  .title {
    height: 42px;

    &-single {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 10px;
      font-size: 18px;
    }
  }

  .content {
    height: calc(100% - 55px);
    width: 100%;
  }
}
</style>
